/**
 * The redesign's segmented tabs (guide §3): a `--color-divider` track with compact, borderless buttons; the
 * selected tab floats on `--color-surface` with `--shadow-segment` and `aria-selected="true"`. The optional
 * count badge carries the number of blocking items, in fail colours.
 *
 * Buttons, not links: the tabs swap panels in place (step 6.1 wires the scope screen).
 */
export type SegmentedTab = {
  id: string;
  label: string;
  /** Blocking-item count; rendered as a mono pill in fail colours. */
  count?: number;
};

export function SegmentedTabs({
  label,
  tabs,
  currentId,
  onSelect,
}: {
  /** Accessible name for the tab list (a `scope.*` key, once step 6.1 adds it). */
  label: string;
  tabs: readonly SegmentedTab[];
  currentId: string;
  onSelect: (id: string) => void;
}): JSX.Element {
  return (
    <div className="stabs" role="tablist" aria-label={label}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={tab.id === currentId}
          className="stabs__tab"
          onClick={() => onSelect(tab.id)}
        >
          {tab.label}
          {tab.count === undefined ? null : <span className="stabs__count">{tab.count}</span>}
        </button>
      ))}
    </div>
  );
}
